import { Title, Text, SubTitle, Button } from "@dspworkplace/ui";
import styled from "styled-components";
import { Btn } from "../Grid/Tools/Filter/Filter";
import { LoadingWrapper } from "../Loading";
import { ScrollyModalStyle, ScrollyOverlayStyle } from "../Modal";

export const CustomTitle = styled(Title)`
    color: #1D5388;
    font-size: 30px;
    line-height: 1.2;
    font-weight: 600;
`;

export const CustomText = styled(Text)`
    color: #64748b;
    font-size: 14px;
    margin-top: 4px;
    line-height: 20px;
`;

export const CustomSubTitle = styled(SubTitle)`
    color: #1d293d;
    font-weight: 600;
    font-size: 18px;
    line-height: 1.55556;
    margin-bottom: 16px;
`;

export const VMTSubMenu = styled.ul`
    list-style:none;
    margin:0;
    padding:0;

    > li {
        margin-bottom: 4px;

        > a {
            width: 100%;
            white-space: nowrap;
            padding-block: 10px;
            padding-inline: 12px;
            color: #00538a;
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 1.42857;
            min-height: 36px;
            font-weight: 500;
            border-radius: 4px;

            &:hover {
                background: #f8fafc;
            }

            &.active {
                background: #00538a1a;
                border-left: 3px solid #00538a;
            }
        }
    }
`;

export const CustomTextSmall = styled(Text)`
    font-size: 12px;
    color: #62748e;
    margin-top: 2px;
    line-height: 1.334;
    white-space: nowrap;
`;

export const FilterBtn = styled(Btn)`
    padding-inline: 12px;
    color: #00538a;
    background-color: #fff;
    white-space: nowrap;
    border-radius: 4px;
    font-weight: 500;
    font-size: 14px;
    padding-block: 8px;
    border: 1px solid #cad5e2;
    margin-bottom: ${({ noMargin }) => (noMargin ? "0" : "5px")};
    height: 36px;
    display: flex;
    align-items: center;
    gap: 6px;
    border-color: #00538a;

    &:hover, &:focus {
        color: #fff;
        background-color: #00538a0d;
        box-shadow: none;
    }
`

export const FilterBtnVMT = styled(Btn)`
    padding-inline: 12px;
    color: #00538a;
    background-color: #0000;
    white-space: nowrap;
    border-radius: 2px;
    font-weight: 500;
    font-size: 14px;
    padding-block: 8px;
    border: 1px solid #00538a;
    height: 36px;

    &:hover {
        color: #fff;
        background-color: #00538a0d;

        svg path {
            fill: #fff;
        }
    }
`

export const BadgeVMT = styled.div`
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 10px;
    font-weight: bold;
    font-family: sans-serif;
    color: #fff;
    background: #D94C53;
    border-radius: 50%;
`;

export const ExportActionIcon = styled(Button)`
    padding: 8px;
    border-radius: 4px;
    z-index: 1;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${props => props.type === "cancel" ? `
    &:hover,
    &:focus,
    &:active {

        svg path {
            fill: #314158;
        }
        background-color: #f1f5f9;
    }
    ` : ""}
`;

export const AddNewVMT = styled(Button)`
    padding: unset;
    height: unset;
    line-height: unset;
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 2px;
    background-color: #ea7b2c;
    padding-block: 8px;
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
    color: #fff;
    padding-inline: 12px;

    &:hover {
        background-color: #d56a1f;
    }
`;

export const ReportIssueBtn = styled(Btn)`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 8px 16px;
    background-color: #e8f4fc;
    border: 1px solid #c5e2f5;
    border-radius: 4px;
    color: #0071bc;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857;

    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    &:hover {
        background-color: #d6ecfa;
    }
`

export const TagInputWrapperVA = styled.div`
    div:has(.tagEventPrevent) {
        width: 100%;
    }

    .tagEventPrevent {
        width: 100%;
        border-radius: 4px;
        font-size: 14px;
        appearance: button;
        cursor: default;
        border: none;
        color: #90a1b9;
        background-color: transparent;

        &:focus, &:focus-within {
            border: none;
            box-shadow: none;
        }

        ul.small {
            max-width: unset;
            color: #90a1b9;
            border: 1px solid #e2e8f0;
            text-align: left;
            background-color: #fff;
            border-radius: 4px;
            width: fit-content !important;
            gap: 8px;

            li {
                width: 100%;
                padding-inline: 12px;
            }

            li:not(.input) {
                color: #0071bc;
                height: 33px;
                font-size: 14px;
                font-weight: 400;
                padding-block: 6px;
                padding-inline: 12px;
                background-color: #e9f0f6;
                border: 1px solid #0071bc33;
                border-radius: 4px;
                white-space: nowrap;
                width: fit-content !important;
                padding: 0 12px !important;
            }

            li:not(.input) svg path {
                fill: #0071bc !important;
            }

            li.input {
                margin-top: 3px;
            }

            li.input input::placeholder {
                color: #90a1b9;
            }

        }

        ul.small:has(li:nth-child(2)) {
            background-color: transparent;

            li.input {
                display: none;
                background-color: transparent;

                input {
                    background-color: transparent;
                }

            }

        }

        ul.small:has(li:nth-child(2)) {
            border: none;
        }

        ul:not(.small) {
            max-width: unset;
            --tw-shadow: 0 20px 25px -5px #0000001a, 0 8px 10px -6px #0000001a;
            box-shadow:
                0 20px 25px -5px #0000001a,
                0 8px 10px -6px #0000001a;
            padding-block: 4px;
            background-color: #fff;
            border: 1px solid #e2e8f0;
            border-radius: 4px;
            overflow-y: auto;
            width: 100%;
            max-height: 192px;
            margin-top: 4px;
            scrollbar-width: none;

            li {
                height: 36px;
                color: #314158;
                font-size: 14px;
                line-height: 1.42857;
                text-align: left;
                padding-block: 8px;
                padding-inline: 16px;
                width: 100%;
                appearance: button;
            }

            li.active,
            li:hover {
                background: #f8fafc;
            }
        }
    }
`;

export const TagInputWrapper = styled.div`
    div:has(.tagEventPrevent) {
        width: 100%;
    }

    .tagEventPrevent {
        width: 100%;
        border-radius: 4px;
        font-size: 14px;
        appearance: button;
        cursor: default;
        border: none;
        color: #90a1b9;

        &:focus, &:focus-within {
            border: none;
            box-shadow: none;
        }

        ul.small {
            max-width: unset;
            color: #90a1b9;
            background-color: #fff;
            border: 1px solid #CCCCCC;
            text-align: left;
            border-radius: 4px;
            width: 100%;
            gap: 4px;
            max-height: unset;
            padding: 5px;
            box-shadow: unset;

            li {
                width: 100%;
                padding-inline: 12px;
                background-color: #e9f0f6;
                border: 1px solid #0071bc33;
                border-radius: 4px;
            }
        }

        ul.small li.input {
            background-color: unset;
        }

        ul.small li.input input {
            height: 24px;
        }

        ul:not(.small) {
            max-width: unset;
            padding-block: 4px;
            border: 1px solid #e2e8f0;
            border-radius: 4px;
            overflow-y: auto;
            width: 100%;
            margin-top: 4px;
            scrollbar-width: none;

            li {
                height: 36px;
                color: #314158;
                font-size: 14px;
                line-height: 1.42857;
                text-align: left;
                padding-block: 8px;
                padding-inline: 16px;
                width: 100%;
                appearance: button;
            }

            li.active,
            li:hover {
                background: #f8fafc;
            }
        }
    }
`;

export const HeaderContainer = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CustomButton = styled(Button)`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 8px 12px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #ea7b2c;
    border-radius: 4px;
    height: 36px;

    &:hover {
        background: #d56a1f;
    }
`;

export const CustomLoadingWrapper = styled(LoadingWrapper)`
    background: #fafbfc;
`;

export const CustomModalSubTitle = styled(SubTitle)`
     color: #00538a;
     font-size: 20px;
     font-weight: 700;
`

export const ScrollyModalStyleV2 = styled(ScrollyModalStyle)`
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-width: 1024px;
    width: ${(props) => props.width || '790px'};
    max-height: 90vh;
    border-radius: 8px;
`;

export const ScrollyOverlayStyleV2 = styled(ScrollyOverlayStyle)`
    background-color: #00000066;
    z-index: 99998;
    ${(props) => props.width && `width: ${props.width};`}
`;

export const ModalBodyWrapper = styled('div')`
    padding: ${(props) => props.padding ? props.padding : "20px 24px 0px 24px"};
    ${(props) => props.flexWrap && `flex-wrap: ${props.flexWrap};`}
`;

export const VehicleIDText = styled(Text)`
    font-weight: 700;
    color: #1d293d;
    line-height: 1.42857;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const IconContainer = styled(Button)`
    height: 32px;
    padding: 6px;
    background-color: #0059b31a;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    line-height: unset !important;

    &:hover {
        background-color: #0059b333;
    }
`